import React, { useState } from 'react';
import { FaTrophy, FaLaptop } from 'react-icons/fa';
import { MdStar } from 'react-icons/md';

const Mars = () => {
  const [listItemHovered, setListItemHovered] = useState(null);

  const achievements = [
    {
      icon: <FaTrophy />,
      title: 'Head Girl',
      desc: 'Demonstrated leadership and responsibility in fostering a positive school environment.',
    },
    {
      icon: <MdStar />,
      title: 'Topper in 10th Grade',
      desc: 'Achieved 98% in ICSE board exams.',
    },
    {
      icon: <MdStar />,
      title: 'Top 3 in 12th Grade',
      desc: 'Secured 96% in CBSE board exams.',
    },
    {
      icon: <FaLaptop />,
      title: 'Runner Up at Hackathon++',
      desc: 'Recognized for problem-solving skills and innovation.',
    },
    {
      icon: <FaTrophy />,
      title: 'Internship Winner at HackElite',
      desc: 'Secured a competitive internship opportunity out of over 50 teams.',
    },
    {
      icon: <FaTrophy />,
      title: 'Mentorship Winner at National Level Hackathon',
      desc: 'Selected for post-hackathon mentorship at a national-level hackathon for our project ',
    },
  ];

  return (
    <section style={styles.sectionContainer}>
      <div style={styles.accentBarTop} /> 
      <div style={styles.sectionContent}>
        <h1 style={styles.header}>🚀 Leadership Positions & Achievements</h1>

        <h2 style={styles.subHeader}>🛠️ Clubs & Leadership</h2>
        <p style={styles.paragraph}>
          <strong style={styles.roleHighlight}>Co-Lead - OSCode DSCE:</strong> Led strategic planning, resource allocation, and execution of tech talks and a national-level hackathon for a 40+ member college tech club. Fostered cross-campus student engagement and collaboration to promote skill development and open-source contributions.
        </p>

        <h2 style={styles.subHeader}>🏆 Awards & Achievements</h2>
        <ul style={styles.gridList}>
          {achievements.map((item, index) => (
            <li
              key={index}
              style={{
                ...styles.cardItem,
                backgroundColor: listItemHovered === index ? 'rgba(28, 28, 59, 0.8)' : 'rgba(255, 255, 255, 0.05)',
                boxShadow: listItemHovered === index ? '0 0 15px #0073FF' : 'none',
                transform: listItemHovered === index ? 'scale(1.05)' : 'scale(1)',
              }}
              onMouseEnter={() => setListItemHovered(index)}
              onMouseLeave={() => setListItemHovered(null)}
            >
              <span style={styles.icon}>{item.icon}</span>
              <strong style={styles.itemTitle}>{item.title}:</strong> {item.desc}
            </li>
          ))}
        </ul>
      </div>
       <div style={styles.accentBarBottom} /> 
    </section>
  );
};

const styles = {
  sectionContainer: {
    padding: '20px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  sectionContent: {
  backgroundColor: 'rgba(0,0,0,0.1)',    // lighter, more transparent
  boxShadow: 'none',                     // remove overall glow here     // keep pink accent bar for structure
  backdropFilter: 'blur(10px)',
  borderRadius: '20px',
  padding: '20px',
  width: '90%',
  maxWidth: '900px',
  color: 'white',
},
accentBarTop: {
  position: 'absolute',
  top: 0,
  left: 0,
  height: '6px',
  width: '100%',
  borderRadius: '20px 20px 0 0',
  background: 'linear-gradient(90deg, #ff4c8b, #00ccff)',
  zIndex: 10,
},
accentBarBottom: {
  position: 'absolute',
  bottom: 0,
  left: 0,
  height: '6px',
  width: '100%',
  borderRadius: '0 0 20px 20px',
  background: 'linear-gradient(90deg, #ff4c8b, #00ccff)',
  zIndex: 10,
},

  header: {
    fontSize: '2.5rem',
    color: '#ff4c8b',
    marginBottom: '30px',
    textAlign: 'center',
  },
  subHeader: {
    fontSize: '1.6rem',
    color: '#00ccff',
    marginTop: '25px',
    marginBottom: '10px',
  },
  roleHighlight: {
    color: '#FFB400',
  },
  paragraph: {
    fontSize: '1rem',
    lineHeight: '1.7',
    marginBottom: '20px',
    color: '#ddd',
  },
  gridList: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
    gap: '16px',
    padding: 0,
    listStyle: 'none',
  },
  cardItem: {
    padding: '20px',
    borderRadius: '15px',
    transition: 'all 0.3s ease-in-out',
    cursor: 'pointer',
    color: '#ffffff',
    backgroundColor: 'rgba(0, 0, 0, 0.1)',
  },
  icon: {
    marginRight: '10px',
    color: '#00ffcc',
    fontSize: '1.2rem',
  },
  itemTitle: {
    color: '#FFD700',
  },
};

export default Mars;
